import { createConsumer, type Consumer } from "@rails/actioncable"

let consumer: Consumer | null = null

export function getActionCableConsumer(): Consumer {
  if (!consumer) {
    consumer = createConsumer()
  }

  return consumer
}
